import { Inject, Injectable, Renderer2, RendererFactory2, DOCUMENT } from '@angular/core';


import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ScriptService {
    private renderer!: Renderer2;

    constructor(rendererFactory: RendererFactory2, @Inject(DOCUMENT) private document: Document) {
        this.renderer = rendererFactory.createRenderer(null, null);
    }

    public loadScriptsHeader(scripts: string): Observable<boolean> {
        return new Observable<boolean>(observable => {
            const containerScripts = this.renderer.createElement('span');
            this.renderer.setProperty(containerScripts, 'innerHTML', scripts);

            Array.from(containerScripts.querySelectorAll('script')).forEach((tmpScript: any) => {
                const newScript: HTMLScriptElement = this.renderer.createElement('script');
                Array.from(tmpScript.attributes).forEach((attr: any) => newScript.setAttribute(attr.name, attr.value));
                newScript.innerHTML = tmpScript.innerHTML;
                this.renderer.appendChild(this.document.getElementsByTagName('head')[0], newScript);
            });

            observable.next(true);
        });
    }

    public loadNoScriptBody(markup: string): Observable<boolean> {
        return new Observable<boolean>(observable => {
            const containerScripts = this.renderer.createElement('span');
            this.renderer.setProperty(containerScripts, 'innerHTML', markup);

            const body = this.document.getElementsByTagName('body')[0];
            Array.from(containerScripts.querySelectorAll('noscript')).forEach((noScript: any) => {
                this.renderer.insertBefore(body, noScript, body.firstChild);
            });

            observable.next(true);
        });
    }

    public loadScriptBodyElement(id: string, scripts?: string): Observable<boolean> {
        return new Observable<boolean>(observable => {
            if (scripts) {
                const containerScripts = this.renderer.createElement('span');
                this.renderer.setProperty(containerScripts, 'innerHTML', scripts);

                Array.from(containerScripts.querySelectorAll('script')).forEach((tmpScript: any) => {
                    const newScript: HTMLScriptElement = this.renderer.createElement('script');
                    Array.from(tmpScript.attributes).forEach((attr: any) => newScript.setAttribute(attr.name, attr.value));
                    this.renderer.appendChild(this.document.getElementById(id), newScript);
                });
            }

            observable.next(true);
        });
    }
}
